import { handleAction } from "redux-actions";
import { getDepth } from "./depth";

export default (state) => {
  return state;
};
